module.exports = __webpack_public_path__ + "static/media/xxLarge.231c4369.png";